import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MenuTopComponent } from './menu-top/menu-top.component';
import { FooterComponent } from './footer/footer.component';
import { NavToggleDirective } from './directives/nav-toggle/nav-toggle.directive';
import { ServicesBlockComponent } from './services-block/services-block.component';
import { TipsBlockComponent } from './tips-block/tips-block.component';

@NgModule({
  imports: [
	CommonModule,
	RouterModule
  ],
  declarations: [
    MenuTopComponent,
	FooterComponent,
    NavToggleDirective,
	ServicesBlockComponent,
	TipsBlockComponent,
  ],
  exports: [
	MenuTopComponent,
	FooterComponent,
	NavToggleDirective,
	ServicesBlockComponent,
	TipsBlockComponent
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/shared/shared.module.ts